import React from 'react';
import { ItineraryRoute } from 'gql/autogen/ItineraryRoute';
import { Location } from 'gql/autogen/Location';
import RouteItemComponent from 'component/page/detail/Itineraries/HopOnHopOffItinerary/RouteItem/RouteItem';

interface Props {
    itineraryRoute: ItineraryRoute;
    locations: Location[];
    contentLocale: string;
}

const ItineraryRouteComponent: React.FC<Props> = (props) => {
    const { itineraryRoute, locations, contentLocale } = props;
    if (!itineraryRoute.routes || itineraryRoute.routes.length === 0) {
        return null;
    }
    return (
        <div data-testid="itinerary-route-container">
            {itineraryRoute.routes.map((route, index) => (
                <RouteItemComponent key={index} routeItem={route} locations={locations} contentLocale={contentLocale} />
            ))}
        </div>
    );
};
ItineraryRouteComponent.displayName = 'ItineraryRouteComponent';

export default ItineraryRouteComponent;
